import {RECOMMEND} from "utils/constants/assets";
import {ACTION_TYPE} from "utils/constants";

const initialState = {
  isOpened: true,
  currentType: RECOMMEND,
  isUsedAsProperty: false,
  currentSearchParams: {},
};

export const handleLibrary = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.HANDLE_ASSET_LIBRARY:
      return {
        ...state,
        ...action.payload,
      };
    case ACTION_TYPE.HANDLE_ASSET_LIBRARY_OPEN:
      return {
        ...state,
        isOpened: !state.isOpened,
      };
    case ACTION_TYPE.SET_CURRENT_SEARCH_PARAMS:
      return {
        ...state,
        currentSearchParams: {...action.payload},
      };
    default:
      return state;
  }
};

export default handleLibrary;
